import {useContext} from 'react';

import {Auth0APISetupContext} from './Auth0APISetupProvider';

const useAuth0APISetup = () => {
    const context = useContext(Auth0APISetupContext);

    return context;
};

export default useAuth0APISetup;
